export default {
  title: 'Comprar tarjetas de regalo',
  subtitle:
    'Dilo con una tarjeta de regalo de {{companyName}}. Perfecta para cumpleaños, agradecimientos o simplemente porque sí – canjeable en comida y bebidas.',
  header: {
    title: 'Tarjeta de regalo',
    subtitle: 'Regala alegría',
  },
  buttons: {
    buy_now: 'Comprar ahora',
  },
};
